import SettingFrame from "../../../../components/@settings/SettingFrame";
import NewInjectionProp from "../../../../components/@injection_props/NewInjectionProp";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function InjectionPropNewPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <NewInjectionProp
                routeType={routeType}
            />
        </SettingFrame>
    )
}       